<template>
    <div class="cash-withdrawal" style="padding-top: 1rem">
        <!--<navTitle title="绑定电子钱包"></navTitle>-->
        <navTitle :title=" $router.app._route.query.ti ? $router.app._route.query.ti : 'Link e-wallet'" :path="path"></navTitle>
        <div class="row-wrap">
            <div class="row-T1">Select e-wallet</div>
            <div class="row">
                <div class="row-name">Service provider</div>
                <select class="select" v-model="cashName">
                    <option value="">Please select service provider</option>
                    <option v-for="(item, index) in payList" :key="index" :value="item.name">
                        <!--<img :src="item.icon" alt="">-->
                        {{ item.name }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="showSubmit">
            <div class="row-wrap">
                <div class="row-T1">E-wallet details</div>
                <div v-if="cashName==='BinancePay'">
                    <div class="row">
                        <div class="row-name">Phone</div>
                        <input class="input" placeholder="Enter your phone" v-model="post.phone"/>
                    </div>
                    <div>
                        <div class="row">
                            <div class="row-name">Binance ID</div>
                            <input class="input" type="number" placeholder="Enter Binance ID"
                                   v-model="post.binance_id"/>
                        </div>
                        <div class="row">
                            <div class="row-name">Pay nickname</div>
                            <input class="input" placeholder="Pay nickname" v-model="post.name"/>
                        </div>
                        <div class="row">
                            <div class="row-name">Pay ID</div>
                            <input class="input" type="number" placeholder="Enter Pay ID"
                                   v-model="post.binance_pay_id"/>
                        </div>
                    </div>
                </div>
                <div v-else-if="cashName==='TopPay'">
                    <div class="row">
                        <div class="row-name">BankName</div>
                        <select class="select" v-model="top_pay_name">
                            <option value="">Please select a bank</option>
                            <option v-for="(v,k) in bank_list" :key="k" :value="v.bank_short_name">{{v.bank_name}}
                            </option>
                        </select>
                    </div>
                    <div class="row">
                        <div class="row-name">Phone</div>
                        <input class="input" placeholder="Enter your phone" v-model="post.phone"/>
                    </div>
                    <div>
                        <div class="row">
                            <div class="row-name">BankNumber</div>
                            <input class="input" type="number" placeholder="Enter Bank Number"
                                   v-model="post.bank_number"/>
                        </div>
                        <div class="row">
                            <div class="row-name">AccountHoldName</div>
                            <input class="input" placeholder="Account Hold Name" v-model="post.account_hold_name"/>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="row-name">Account</div>
                        <input class="input" placeholder="Enter your account name" v-model="post.name"/>
                    </div>
                    <div class="row">
                        <div class="row-name">Phone</div>
                        <input class="input" placeholder="Format:09*********" v-model="post.phone"/>
                    </div>
                </div>
            </div>
            <div class="tips">
<!--                *Please check and confirm all details are correct, incorrect details will delay top up.-->
                *Please confirm that the account information is completely correct, otherwise the withdrawal may not be completed
            </div>
            <div class="remark">
                *Choose 1 from 2 first-time binding bonuses, PayMaya will get ₱20, GCash will get ₱30
            </div>
            <div class="submit bg-color-blue" @click="submitted">Bind</div>
        </div>

        <div v-if="!showSubmit && cashName">
            <div class="row-wrap">
                <div class="row-T1">Unbind cash account</div>
                <div v-if="cashName==='BinancePay'">
                    <div class="row">
                        <div class="row-name">Phone</div>
                        <input class="input" readonly placeholder="Enter your phone" v-model="select_cash.phone"/>
                    </div>
                    <div>
                        <div class="row">
                            <div class="row-name">Binance ID</div>
                            <input class="input" readonly placeholder="Enter Binance ID"
                                   v-model="select_cash.binance_id"/>
                        </div>
                        <div class="row">
                            <div class="row-name">Pay nickname</div>
                            <input class="input" v-if="select_cash.is_edit === 1" placeholder="Pay nickname"
                                   v-model="select_cash.account"/>
                            <input class="input" v-else readonly placeholder="Pay nickname"
                                   v-model="select_cash.account"/>
                            <div v-if="select_cash.is_edit === 1" class="nickname-edit" @click="nicknameEdit()">
                                Edit
                            </div>
                        </div>
                        <div class="row">
                            <div class="row-name">Pay ID</div>
                            <input class="input" type="number" readonly placeholder="Enter Pay ID"
                                   v-model="select_cash.binance_pay_id"/>
                        </div>
                    </div>
                </div>
                <div v-else-if="cashName==='TopPay'">
                    <div class="row">
                        <div class="row-name">BankName</div>
                        <div class="row">
                            <input class="input" placeholder="Enter your phone" v-model="select_cash.bank_name"
                                   disabled="disabled"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-name">Phone</div>
                        <input class="input" placeholder="Enter your phone" v-model="select_cash.phone" disabled="disabled"/>
                    </div>
                    <div>
                        <div class="row">
                            <div class="row-name">BankNumber</div>
                            <input class="input" type="number" placeholder="Enter Bank Number"
                                   v-model="select_cash.bank_number" disabled="disabled"/>
                        </div>
                        <div class="row">
                            <div class="row-name">AccountHoldName</div>
                            <input class="input" placeholder="Account Hold Name" v-model="select_cash.account_hold_name"
                                   disabled="disabled"/>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="row-name">Account</div>
                        <input class="input" placeholder="Please enter your account" v-model="select_cash.account"
                               disabled="disabled"/>
                    </div>
                </div>
                <!--<div class="row">-->
                <!--<div class="row-name">Phone</div>-->
                <!--<input-->
                <!--class="input"-->
                <!--placeholder="Please enter the phone number of the binding"-->
                <!--v-model="removeData.phone"-->
                <!--/>-->
                <!--</div>-->
            </div>

            <div class="tips">
                *Please confirm that the account information is completely correct, otherwise the withdrawal may not be completed
<!--                *If you want to bind other account, please contact customer service to unbind.-->

                <!--*Please unbind current account, if you do not know the phone number binded, please contact customer service to unbind.-->
            </div>
            <div class="remark">
                *Choose 1 from 2 first-time binding bonuses, PayMaya will get ₱20, GCash will get ₱30
            </div>
            <!--<div class="submit bg-color-blue" @click="upadte">Unbind</div>-->
            <div class="submit" style="background: #CCC">Unbind</div>

        </div>
    </div>
</template>
<script>
    import {
        recharge_bind_cash,
        recharge_info,
        getUser,
        // recharge_ubind_cash,
        setBinanceNickname,
        getTopPayBankList
    } from "../../api/user";
    import navTitle from "@components/navTitle";

    export default {
        name: "myPay",
        components: {navTitle},
        props: {},
        watch: {
            cashName(n, o) {
                // console.log(n, o);
                let list = this.my_cash;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].type === n) {
                        this.select_cash = list[i];
                        this.showSubmit = false;
                        return;
                    }
                }
                this.showSubmit = true;
            },
            top_pay_name(n, o) {
                // console.log(n);
                if (n === '') {
                    this.post.bank_name = '';
                    this.post.bank_code = '';
                    return;
                }
                let list = this.bank_list;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].bank_short_name === n) {
                        this.post.bank_code = list[i].bank_short_name;
                        this.post.bank_name = list[i].bank_name;
                        return;
                    }
                }
            }
        },
        data: function () {
            return {
                payList: {},
                my_cash: [], //已经绑定的电子钱包
                select_cash: [],
                path:'/user',

                showSubmit: true, //默认显示新增绑定
                cashName: "",
                // cashName: "GCash",
                post: {
                    cashName: "",
                    name: "",
                    phone: "",
                    binance_id: "",
                    binance_pay_id: "",
                    bank_number: "",
                    account_hold_name: "",
                    bank_name: "",
                    bank_code: ""
                },
                removeData: {},
                banks: ["Gcash", "juanCash"],
                bank_list: [],
                top_pay_name: ''
            };
        },
        mounted: function () {
            this.getList();
            // this.getTopPayBank();
            this.bindAlert()
        },
        methods: {
            bindAlert() {
                const v = parseInt(this.$route.query.r)
                if (v === 1) {
                    this.path='/'
                    this.$dialog.confirm({
                        mes: 'Register successfully and get cash bonus immediately after binding!',
                        title: "Tip",
                        opts: [
                            {
                                txt: "Sure",
                                color: "#00C3F9",
                                callback: () => {
                                }
                            }
                        ]
                    })
                }
            },
            getTopPayBank() {
                let that = this
                getTopPayBankList().then(res => {
                    that.bank_list = res.data.bank_list
                })
            },
            nicknameEdit() {
                if (!this.select_cash.account.trim()) {
                    return this.$dialog.toast({mes: "Please enter Pay nickname"});
                }
                let that = this
                this.$dialog.confirm({
                    mes: "<b style='color: red'>Note</b>: Pay nickname can only be modified once ! ! !<br>Pay nickname: <b style='color: red'>" + that.select_cash.account + "</b>",
                    title: "Binance Pay nickname Edit",
                    opts: [
                        {
                            txt: "Cancel",
                            color: false,
                            callback: () => {
                                return that.$dialog.toast({mes: "Cancelled"});
                            }
                        },
                        {
                            txt: "Confirm",
                            color: "#00C3F9",
                            callback: () => {
                                that.$dialog.loading.open('loading...')
                                setBinanceNickname({
                                    account: that.select_cash.account,
                                    cash_id: that.select_cash.id
                                }).then(res => {
                                    // console.log(res)
                                    that.select_cash.is_edit = 1
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                }).catch(res => {
                                    // console.log(res)
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg});
                                });
                            }
                        }
                    ]
                });
            },
            getList() {
                recharge_info().then(res => {
                    // console.log('getList',res.data)
                    // this.payList = res.data.types;
                    this.payList = {GCash:{ico:'',name:'GCash'},PayMaya:{ico:'',name:'PayMaya'}}
                    this.my_cash = res.data.my_cash;

                    this.cashName = this.my_cash[0].type

                    // this.cashName = ""
                    // this.showSubmit = true
                    // this.removeData = {}
                });
            },
            submitted() {
                if (!this.cashName) {
                    this.$dialog.toast({mes: "Please select an cash platform"});
                    return;
                }
                if (this.cashName === 'TopPay') {
                    this.post.name = 'topPay'
                }
                if (!this.post.name) {
                    this.$dialog.toast({mes: "Please enter username"});
                    return;
                }
                if (!this.post.phone) {
                    this.$dialog.toast({mes: "Please enter phone number"});
                    return;
                }

                /*if (this.cashName === 'PayMaya') {
                    getUser().then(res => {
                        if (res.data.level === 0) {
                            return this.$dialog.toast({mes: "Must be VIP to bind"});
                        }
                    });
                }*/
                if (this.cashName === 'BinancePay') {
                    if (!this.post.binance_id.trim()) {
                        this.$dialog.toast({mes: "Please enter Binance ID"});
                        return;
                    }
                    if (!/^\d+$/.test(this.post.binance_id.trim())) {
                        return this.$dialog.message("Binance ID format error");
                    }
                    if (!this.post.name.trim()) {
                        this.$dialog.toast({mes: "Please enter Pay nickname"});
                        return;
                    }
                    if (!this.post.binance_pay_id) {
                        this.$dialog.toast({mes: "Please enter Pay ID"});
                        return;
                    }
                    if (!/^[1-9]\d+$/.test(this.post.binance_pay_id.trim())) {
                        return this.$dialog.message("Pay ID format error");
                    }
                    if (this.post.binance_pay_id.trim().length > 12) {
                        return this.$dialog.message("Pay ID length error");
                    }
                    if (this.post.binance_id.trim() === this.post.binance_pay_id.trim()) {
                        return this.$dialog.toast({mes: "Binance ID is not Pay ID, Pay ID can be found on the receive page."});
                    }
                }

                if (this.cashName === 'TopPay') {
                    this.post.name = this.post.account_hold_name
                    if (this.post.bank_name.trim() === '') {
                        this.$dialog.toast({mes: "Please select a bank"});
                        return;
                    }
                    if (!/^\d+$/.test(this.post.bank_number.trim())) {
                        return this.$dialog.message("Bank number format error");
                    }
                    let re = new RegExp("^[a-zA-Z]+$")
                    if (!re.test(this.post.account_hold_name.trim())) {
                        return this.$dialog.message("Cardholder name must be letters or remove spaces");
                    }
                }
                this.$dialog.loading.open("Loading...");
                let param = {
                    type: this.cashName,
                    phone: this.post.phone,
                    account: this.post.name,
                    binance_id: this.post.binance_id,
                    bank_name: this.post.bank_name,
                    bank_code: this.post.bank_code,
                    bank_number: this.post.bank_number,
                    account_hold_name: this.post.account_hold_name
                }
                // console.log(param)
                // return
                let that = this
                recharge_bind_cash(param).then(res => {
                    that.$dialog.loading.close();
                    // console.log('绑定账户',res)
                    // this.$dialog.success("Link success，You get ₱" + res.data.money) + ".";
                    /*this.$dialog.success("Bonus ₱"+ res.data.money+", go make money!");
                    setTimeout(function () {
                        location.reload();
                    }, 3000)*/

                    // location.reload();
                    // this.getList()
                    that.$dialog.confirm({
                        mes: "Bonus ₱"+ res.data.money+", go make money!",
                        title: "Tip",
                        opts: [
                            {
                                txt: "Sure",
                                color: "#00C3F9",
                                callback: () => {
                                    that.$router.replace({path: "/detail/1"})
                                }
                            }
                        ]
                    })

                })
                    .catch(res => {
                        this.$dialog.loading.close();
                        this.$dialog.error(res.msg);
                    });
            },
            /*upadte() {

              if (!this.cashName) {
                this.$dialog.toast({ mes: "Please select an cash platform" });
                return;
              }
              if (!this.removeData.phone) {
                this.$dialog.toast({ mes: "Please enter your phone" });
                return;
              }
              this.$dialog.loading.open("Loading...");
              recharge_ubind_cash(this.select_cash.id, {
                phone: this.removeData.phone
              })
                .then(res => {
                  this.$dialog.loading.close();
                  // console.log('绑定账户',res)
                  this.$dialog.success("Link success");
                  // this.getList()
                  location.reload();
                })
                .catch(res => {
                  this.$dialog.loading.close();
                  this.$dialog.error(res.msg);
                });
            }*/
        }
    };
</script>
<style scoped>
    .cash-withdrawal {
        padding: 0.3rem;
        box-sizing: border-box;
        /*background: #FAFAFA;*/
    }

    .row-T1 {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
    }

    .row-info {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
        color: #999;
        margin-top: -10px;
    }

    .value-item {
        width: 100%;
        /*height: 5rem;*/
        background: #fff;
        padding: 0.27rem 0.27rem 0 0.27rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .value-item .flex {
        display: flex;
        width: 100%;
        height: 1.2rem;
        border-bottom: 1px solid #eee;
    }

    .value-item .T1 {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
    }

    .value-item .flex .I1 {
        width: 0.4rem;
        font-size: 0.85rem;
        line-height: 1.2rem;
        height: 1.2rem;
    }

    .value-item .flex input {
        width: 6rem;
        border: none;
        line-height: 1.2rem;
        height: 1.2rem;
        font-size: 0.65rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
    }

    .value-item .max {
        width: 100%;
        line-height: 1rem;
        height: 1rem;
    }

    .value-item .min {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .href {
        color: #0c7cd8;
    }

    .row-wrap {
        /*margin-bottom: 0.3rem;*/
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 1rem;
        line-height: 1rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .submit {
        width: 100%;
        height: 0.92rem;
        background: rgba(0, 195, 249, 1);
        border-radius: 7px;
        color: #fff;
        line-height: 0.92rem;
        text-align: center;
        font-size: 0.35rem;
        margin-top: 1rem;
    }

    .tips {
        margin-top: 10px;
        color: #999;
    }
    .remark{
        margin-top: 10px;
        color: red;
        font-size: .2rem;
    }

    .nickname-edit {
        border-radius: 5px;
        color: #fff;
        background-color: #00c3f9 !important;
        height: 30px;
        font-size: .25rem;
        line-height: .5rem;
        padding: 0px 4px;
        margin-top: 15px;
    }
</style>
